import s from './style.module.scss';
import { Input } from 'antd';

import { Display } from '@/components/Display/Display';
import { inject, observer } from 'mobx-react';
import GrtTextArea from '@/components/Web/GrtTextArea';
const MultiChoice = (props) => {
    const { simulation } = props.store;
    let { curUserAnswer, curQuestion, setCurUserAnswer, loading } = simulation;

    const onCheckChange = (item) => {
        let value = item.id;
        let isCustom = item.customer_input;
        if (loading) {
            return;
        }
        let checkValue = curUserAnswer?.user_answer || [];
        let temValue = [];
        if (checkValue.includes(value)) {
            temValue = checkValue.filter((id) => id !== value);
        } else {
            temValue = [...checkValue, value];
        }

        setCurUserAnswer({
            user_answer: temValue,
            custom_value: isCustom ? '' : curUserAnswer?.custom_value
        });
    };
    const onChangeInputValue = (e) => {
        if (loading) {
            return;
        }
        setCurUserAnswer({
            custom_value: e.target.value
        });
    };

    return (
        <>
            <div className={s['check-group']}>
                {curQuestion?.options.map((item) => (
                    <div
                        className={s['option-item']}
                        onClick={() => onCheckChange(item)}
                        data-active={curUserAnswer?.user_answer.includes(item.id)}
                        key={item.id}
                    >
                        <div className={s['option-item-content']}>
                            <span data-active={curUserAnswer?.user_answer.includes(item.id)} className={s['option-label']}></span>
                            <span className={s['option-item-content-text']}>{item.content}</span>
                        </div>
                        <Display show={item.customer_input && curUserAnswer?.user_answer.includes(item.id)}>
                            <div className={s['custom-input']}>
                                <div>
                                    <GrtTextArea
                                        style={{ resize: 'none' }}
                                        value={curUserAnswer?.custom_value}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                        }}
                                        onFocus={(e) => {
                                            e.stopPropagation();
                                        }}
                                        onChange={onChangeInputValue}
                                        autoSize={{ minRows: 3, maxRows: 3 }}
                                        placeholder="请输入自定义内容"
                                        maxLength={200}
                                        showCount
                                    />
                                </div>
                                <Display show={true}>
                                    <div className={s['custom-input-err-tip']}>
                                        {!curUserAnswer?.custom_value || curUserAnswer?.custom_value.trim() === '' ? '内容不能为空' : ''}
                                    </div>
                                </Display>
                            </div>
                        </Display>
                    </div>
                ))}
            </div>
        </>
    );
};
export default inject('store')(observer(MultiChoice));
